module.exports = __webpack_public_path__ + "fonts/scale.svg";